import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth.jsx';
import { STEPS, loadSetupData, setupStatus } from '../pages/setupSteps.js';

// "Finish setting up": brings the first-run guide back for an owner or admin who skipped
// it (or finished it with steps left). Hidden once every step is done, and for a fortnight
// after "Hide for now".
const HIDE = (orgId) => `ss_setup_prompt_hidden_${orgId}`;
const HIDE_DAYS = 14;

function hiddenNow(orgId) {
  try { const t = Number(localStorage.getItem(HIDE(orgId))); return t && Date.now() - t < HIDE_DAYS * 864e5; } catch { return false; }
}

export default function SetupPrompt() {
  const { organisation, user } = useAuth();
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(() => (organisation ? hiddenNow(organisation.id) : true));
  const canSetUp = organisation && ['owner', 'admin'].includes(organisation.role || organisation.my_role);

  useEffect(() => {
    if (!canSetUp || hidden) return;
    let live = true;
    loadSetupData(organisation.id).then((d) => { if (live) setStatus(setupStatus({ ...d, user })); }).catch(() => {});
    return () => { live = false; };
  }, [canSetUp, hidden, organisation, user]);

  if (!canSetUp || hidden || !status) return null;
  const left = STEPS.filter((s) => !status[s.key]);
  if (!left.length) return null;
  const done = STEPS.length - left.length;

  const hide = () => {
    try { localStorage.setItem(HIDE(organisation.id), String(Date.now())); } catch { /* private mode */ }
    setHidden(true);
  };

  return (
    <section className="card setup-prompt" aria-labelledby="setup-prompt-h">
      <div className="setup-prompt-text">
        <h2 id="setup-prompt-h">Finish setting up</h2>
        <p className="muted">{done} of {STEPS.length} done. Next: {left[0].short.toLowerCase()}, about {left[0].time}.</p>
        <div className="setup-prompt-bar" role="progressbar" aria-valuemin={0} aria-valuemax={STEPS.length} aria-valuenow={done} aria-label={`${done} of ${STEPS.length} done`}>
          <span style={{ width: `${(done / STEPS.length) * 100}%` }} />
        </div>
        <ul className="setup-prompt-left">{left.map((s) => <li key={s.key}>{s.short}</li>)}</ul>
      </div>
      <div className="setup-prompt-actions">
        <Link to={`/setup?step=${left[0].key}`} className="btn btn-primary">Carry on setting up</Link>
        <button type="button" className="btn btn-secondary" onClick={hide}>Hide for now</button>
      </div>
    </section>
  );
}
